export default {
  title: '快递运价管理',
  createTitle: '新增快递运价',
  editTitle: '编辑快递运价',
  viewTitle: '查看快递运价',
  copyTitle: '复制快递运价',
  tabs: {
    all: '全部',
    express: '快递',
    ltl: '零担',
    ftl: '整车'
  },
  filters: {
    supplierEnterprise: '供应商',
    priceNo: '运价编码',
    batchNo: '生成批次号',
    loadMode: '装载模式',
    supplier: '快递运营商',
    billingModel: '计费模型',
    origin: '发货国家',
    destination: '目的国家',
    source: '运价来源',
    billingMethod: '计费方式',
    cargoType: '货物类型',
    routeType: '路线类型',
    office: '分公司',
    accountNo: '账号',
    serviceType: '服务类型',
    status: '状态'
  },
  columns: {
    supplierEnterprise: '供应商',
    priceNo: '运价编码',
    source: '运价来源',
    loadMode: '装载模式',
    office: '分公司',
    supplier: '快递运营商',
    accountNo: '账号',
    serviceType: '服务类型',
    cargoType: '货物类型',
    volumetricFactor: '体积重系数',
    origin: '发货地',
    destination: '目的地',
    billingModel: '计费模型',
    billingMethod: '计费方式',
    billingDetail: '计费详情',
    surchargeCount: '附加费',
    routeType: '路线类型',
    minBillingWeight: '最小计费重量',
    pickupFee: '提货费',
    deliveryFee: '送货费',
    loadingFee: '装卸费',
    vehicleType: '车型',
    vehicleCapacity: '车型载重',
    vehicleVolume: '车型容积',
    tripPrice: '整车一口价',
    kmPrice: '每公里单价',
    minKm: '最低里程',
    currency: '币种',
    validity: '有效期',
    status: '状态',
    actions: '操作'
  },
  fields: {
    supplierEnterprise: '供应商',
    priceNo: '运价编码',
    source: '运价来源',
    relatedNo: '关联单号',
    office: '分公司',
    supplier: '快递运营商',
    accountNo: '账号',
    loadMode: '装载模式',
    serviceType: '服务类型',
    cargoType: '货物类型',
    specialPriceStatus: '特价状态',
    validPeriod: '有效期',
    beginDate: '生效日期',
    endDate: '失效日期',
    currency: '币种',
    paymentTerm: '结算条款',
    volumetricFactor: '体积重系数',
    minBillingWeight: '最小计费重量',
    pickupFee: '提货费',
    deliveryFee: '送货费',
    loadingFee: '装卸费',
    vehicleType: '车型',
    vehicleCapacity: '车型载重',
    vehicleVolume: '车型容积',
    billingModel: '计费模型',
    billingMethod: '计费方式',
    firstWeightThreshold: '首重阈值(KG)',
    firstWeightPrice: '首重价格',
    additionalWeightUnit: '续重单位(KG)',
    additionalWeightPrice: '续重价格',
    weightTierAdditionalWeightPrice: '续重单价',
    unitPrice: '单价',
    unitPriceVolume: '单价（元/m³）',
    minCharge: '最低收费',
    weightTierMinCharge: '最低收费（总价）',
    pricingMethod: '整车计价方式',
    tripPrice: '整车一口价',
    kmPrice: '每公里单价',
    minKm: '最低里程',
    weightStart: '起始重量',
    weightEnd: '结束重量',
    sortOrder: '排序',
    remarks: '备注',
    billingRemark: '计费备注',
    onePriceAmount: '一口价总价',
    onePriceIncludedItems: '一口价包含项目',
    onePriceRemarks: '一口价备注',
    originAddress: '发货地',
    destinationAddress: '目的地',
    warehouse: '仓库',
    surchargeName: '费用名称',
    surchargeBillingMode: '计费模式',
    surchargeValue: '金额/百分比',
    surchargeUnit: '单位',
    surchargeMinCharge: '最低收费',
    surchargePaymentType: '付费条款',
    isCountTotal: '计入总价',
    isTotalIncluded: '已包含',
    surchargeSource: '费用来源'
  },
  sections: {
    basicInfo: '基本信息',
    routeInfo: '路线信息',
    billingInfo: '计费规则',
    billingDetail: '计费明细',
    ltlFields: '零担信息',
    ftlFields: '整车信息',
    surcharge: '附加费明细',
    remark: '备注'
  },
  placeholders: {
    supplierEnterprise: '请选择供应商',
    priceNo: '请输入运价编码',
    batchNo: '请输入生成批次号',
    source: '请选择运价来源',
    relatedNo: '请输入关联单号',
    office: '请选择分公司',
    supplier: '请选择快递运营商',
    accountNo: '请输入账号',
    loadMode: '请选择装载模式',
    origin: '请选择发货国家',
    destination: '请选择目的国家',
    serviceType: '请选择服务类型',
    surchargeName: '请输入费用名称',
    surchargePaymentType: '请选择付费条款',
    cargoType: '请选择货物类型',
    routeType: '请选择路线类型',
    validPeriod: '请选择有效期',
    beginDate: '请选择生效日期',
    endDate: '请选择失效日期',
    currency: '请选择币种',
    paymentTerm: '请选择结算条款',
    billingModel: '请选择计费模型',
    billingMethod: '请选择计费方式',
    status: '请选择状态',
    specialPriceStatus: '请选择特价状态',
    number: '请输入数值',
    optional: '选填',
    unlimited: '留空表示无上限',
    text: '请输入',
    remarks: '请输入备注',
    billingRemark: '请输入计费备注',
    warehouse: '请选择仓库'
  },
  actions: {
    add: '新增运价',
    import: '导入',
    export: '导出',
    downloadTemplate: '下载模板',
    batchOperations: '批量操作',
    batchPublish: '批量发布',
    batchOffline: '批量下架',
    batchDelete: '批量删除',
    view: '详情',
    edit: '编辑',
    copy: '复制',
    publish: '发布',
    offline: '下架',
    delete: '删除',
    more: '更多',
    reset: '重置',
    saveDraft: '保存草稿',
    cancel: '取消',
    confirm: '确认',
    addTier: '添加重量段',
    addSurcharge: '添加附加费'
  },
  enums: {
    specialPriceStatus: {
      1: '不允许申请特价',
      2: '允许申请特价',
      3: '特价'
    },
    source: {
      1: '手工录入',
      2: 'Excel导入',
      3: '询价入库',
      4: '招标入库'
    },
    loadMode: {
      EXPRESS: '快递',
      LTL: '零担',
      FTL: '整车'
    },
    billingModel: {
      FIRST_ADDITIONAL: '首重+续重',
      UNIT_PRICE: '单价计费',
      WEIGHT_TIER: '重量段阶梯'
    },
    billingMethod: {
      WEIGHT: '按重量',
      VOLUME: '按体积',
      WEIGHT_VOLUME_MAX: '按重量体积取大',
      TICKET: '按票',
      PIECE: '按件',
      TRIP: '按车次',
      KM: '按里程'
    },
    paymentTerm: {
      PREPAID: '预付',
      COLLECT: '到付'
    },
    routeType: {
      DOMESTIC: '国内',
      INTERNATIONAL: '国际',
      PENDING: '待判断'
    },
    serviceType: {
      express: '特快',
      standard: '标快',
      economy: '经济',
      priority_freight: '优先货运',
      economy_freight: '经济货运',
      deferred_freight: '递延货运',
      DHL_EXPRESS_WORLDWIDE: 'DHL 全球快递',
      DHL_EXPRESS_WORLDWIDE_EXPORT: 'DHL 环球快递出口',
      DHL_EXPRESS_WORLDWIDE_IMPORT: 'DHL 环球快递进口',
      DHL_EXPRESS_WORLDWIDE_THIRD_COUNTRY: 'DHL 环球快递三方',
      DHL_ECONOMY_SELECT: 'DHL 经济精选',
      FEDEX_INTERNATIONAL_PRIORITY: 'FedEx 国际优先',
      FEDEX_INTERNATIONAL_ECONOMY: 'FedEx 国际经济',
      UPS_WORLDWIDE_EXPRESS: 'UPS 全球特快',
      UPS_WORLDWIDE_SAVER: 'UPS 全球快捷',
      SF_STANDARD_EXPRESS: '顺丰标快',
      SF_ECONOMY_EXPRESS: '顺丰特惠',
      STANDARD_EXPRESS: '标准快递',
      ECONOMY_EXPRESS: '经济快递'
    },
    surchargeBillingMode: {
      FIXED: '固定金额',
      PERCENTAGE: '百分比'
    },
    surchargePaymentType: {
      PREPAID: '预付',
      COLLECT: '到付',
      PREPAID_OR_COLLECT: '预付/到付'
    },
    surchargeSource: {
      manual: '手工维护',
      system: '系统规则'
    },
    boolean: {
      true: '是',
      false: '否'
    },
    status: {
      1: '待上架',
      2: '正常',
      3: '失效',
      4: '下架',
      5: '禁用',
      6: '待导入'
    }
  },
  routeTypeDescriptions: {
    DOMESTIC: '发货地与目的地国家相同，按国内快递处理。',
    INTERNATIONAL: '发货地与目的地国家不同，按国际快递处理。',
    PENDING: '请选择发货地和目的地国家后自动判断路线类型。'
  },
  billingDetail: {
    firstWeight: '首重',
    additionalWeight: '续重',
    tier: '重量段{index}',
    tierCount: '{count}个重量段',
    noLimit: '不限'
  },
  messages: {
    sourceEditDisabled: '仅手工录入或 Excel 导入的快递运价支持编辑',
    fetchFailed: '获取快递运价失败',
    loadDetailFailed: '加载快递运价详情失败',
    loadDefaultOfficeFailed: '默认分公司加载失败，请手动选择分公司',
    loadCargoTypesFailed: '快递货物类型加载失败，请稍后重试',
    saveSuccess: '草稿保存成功',
    publishSuccess: '运价发布成功',
    offlineSuccess: '运价已下架',
    deleteSuccess: '删除成功',
    batchPublishSuccess: '批量发布成功',
    batchOfflineSuccess: '批量下架成功',
    batchDeleteSuccess: '批量删除成功',
    noSelection: '请先选择运价',
    onlyDraftCanPublish: '只有草稿状态的运价才能发布，当前选中包含：{status}',
    onlyNormalCanOffline: '只有正常状态的运价才能下架，当前选中包含：{status}',
    deleteConfirm: '确定要删除这条运价记录吗？',
    batchDeleteConfirm: '确定要删除选中的运价记录吗？此操作不可恢复。',
    importTitle: '导入快递运价',
    importSelectFile: '点击或拖拽上传 Excel 文件',
    importParsing: '文件已上传，正在创建导入任务...',
    importSubmit: '开始导入',
    importReminderTitle: '导入提示',
    importReminderAsync: '上传后系统会创建异步任务，可在任务管理中查看解析结果。',
    importReminderWarning: '包装方式、运输条款、附加费名称本期暂不导入，非空时会作为提示展示。',
    templateDownloadFailed: '模板下载失败',
    uploadSuccess: '导入任务已创建',
    uploadFailed: '上传失败，请稍后重试',
    detailAddressRequired: '发货地和目的地需选择仓库或填写详情地址',
    weightTierRequired: '请至少维护一条重量段',
    weightTierPriceModeInvalid: '第 {index} 行只能填写单价（续重单价可选）或最低收费（总价），未使用的价格字段必须留空',
    weightTierRangeInvalid: '第 {index} 行重量段范围无效、重叠或无上限段未放在最后',
    weightTierConfigNotFound: '当前快递运营商和服务类型未配置重量段，请手工维护',
    ftlOnlyUnitPrice: '整车模式仅支持单价计费',
    tripPriceRequired: '请填写整车一口价',
    kmPriceRequired: '请填写每公里单价',
    surchargeAtLeastOne: '至少需要保留一个附加费',
    surchargeNameRequired: '请选择第 {row} 行附加费的费用名称',
    surchargeBillingModeRequired: '请选择第 {row} 行附加费的计费模式',
    surchargeValueRequired: '请填写第 {row} 行附加费的单价配置',
    surchargeUnitRequired: '请选择第 {row} 行附加费的单位',
    surchargeCurrencyRequired: '请选择第 {row} 行附加费的币种',
    surchargePaymentTypeRequired: '请选择第 {row} 行附加费的付费条款',
    surchargeCountTotalRequired: '请选择第 {row} 行附加费是否计入总价',
    surchargeIncludedRequired: '请选择第 {row} 行附加费是否已包含',
    copyTip: '复制后会重新生成运价编码，请确认信息后保存',
    onePriceTip: '该运价由一口价报价导入，询价计算不再叠加附加费。',
    surchargeCount: '{count}项附加费',
    exportFilename: '快递运价数据'
  }
}
